
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Volvobusonrentinpune() {



    const cardData =
    {
        keyword: 'Volvo Bus On Rent in Pune',
        heading: 'Samarth Travels: Volvo Bus On Rent in Pune',
        headingDescription: 'Samarth Travels offers Volvo Bus on rent in Pune, ideal for luxury group travel, corporate events, weddings, and outstation tours. Our fleet of well-maintained Volvo buses is equipped with air-conditioning, push-back seats, ample legroom, and spacious interiors to ensure a comfortable and premium journey. With experienced drivers, flexible rental options, and transparent pricing, Samarth Travels provides safe, reliable, and cost-effective Volvo bus rental services across Pune.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

 "services": [
    {
      "name": "Volvo Sleeper Bus Rent Per Km",
      "description": "Rent a Volvo sleeper bus at competitive rates per kilometer in Pune. Ideal for long trips, corporate events, and family tours."
    },
    {
      "name": "Volvo Bus Hire in Pune Near Me",
      "description": "Looking for a Volvo bus to rent near you in Pune? We provide easy access to high-quality Volvo buses for all your travel needs."
    },
    {
      "name": "Sleeper Bus on Rent in Pune",
      "description": "Rent a comfortable sleeper bus in Pune for your long-distance trips. Available for picnics, corporate outings, and family tours."
    },
    {
      "name": "Top AC Sleeper Bus on Rent in Pune",
      "description": "Experience the best in comfort with our top AC sleeper buses available for rent in Pune, perfect for long-distance travel and events."
    },
    {
      "name": "AC Sleeper Bus Rental Service",
      "description": "Our AC sleeper buses offer maximum comfort for your journey. Available for both local and outstation rentals in Pune."
    },
    {
      "name": "AC 50 Seater Bus Sleeper on Rent",
      "description": "Rent a 50-seater AC sleeper bus in Pune for your group travel, including picnics, corporate outings, and more."
    },
    {
      "name": "Volvo Bus on Rent in Pune",
      "description": "Book a Volvo bus for rent in Pune for any occasion. Ideal for family tours, corporate events, weddings, and more."
    },
    {
      "name": "Volvo Bus on Rent in Pune for Family",
      "description": "Rent a Volvo bus for family trips in Pune. Comfortable seating and reliable service for all your family events."
    },
    {
      "name": "Sleeper Bus on Rent in Pune",
      "description": "Comfortable sleeper bus available on rent for both short and long-distance travel in and around Pune."
    },
    {
      "name": "Hire Luxury Bus on Rent",
      "description": "Luxury buses for rent in Pune for all your special occasions including weddings, corporate events, and family trips."
    },
    {
      "name": "Hire Luxury Bus on Rent Near Me in Pimpri Chinchwad",
      "description": "Looking for a luxury bus for rent near Pimpri Chinchwad? We offer luxurious buses for all types of events and outings."
    },
    {
      "name": "Luxury Bus on Rent in Pune",
      "description": "Rent a luxury bus in Pune for corporate events, weddings, and family outings. Comfort and style combined."
    },
    {
      "name": "Volvo Bus on Rent for Picnic",
      "description": "Plan your next picnic with comfort by renting a Volvo bus in Pune. Spacious seating and amenities available for your group."
    },
    {
      "name": "Volvo Bus on Rent for Corporate Event",
      "description": "Rent a Volvo bus for your next corporate event in Pune. Travel in comfort and style while ensuring your team arrives on time."
    },
    {
      "name": "Volvo Bus on Rent for Corporate Picnic",
      "description": "Rent a Volvo bus for your corporate picnic in Pune. Ensure your team travels in style and comfort with our premium buses."
    },
    {
      "name": "Volvo Bus on Rent for Ashtavinayak Darshan",
      "description": "Book a Volvo bus for your Ashtavinayak darshan trip from Pune. Comfortable, spacious, and ideal for a peaceful pilgrimage."
    },
    {
      "name": "Volvo Bus on Rent for 12 Jyotirlinga Darshan",
      "description": "Rent a Volvo bus for your 12 Jyotirlinga darshan tour from Pune. Travel in comfort while visiting the holy sites."
    },
    {
      "name": "Sleeper Bus on Rent in Pune",
      "description": "Comfortable sleeper buses available for rent in Pune. Ideal for long journeys and group travel."
    },
    {
      "name": "Volvo Bus on Rent in Pimpri Chinchwad",
      "description": "Rent a Volvo bus in Pimpri Chinchwad for any event, whether a corporate outing, wedding, or family trip."
    },
    {
      "name": "Volvo Bus on Rent in Pune for Marriage Function",
      "description": "Rent a Volvo bus for your wedding in Pune. Spacious and comfortable transport for your guests to and from the venue."
    },
    {
      "name": "Best Volvo Bus for Hire in Pune",
      "description": "We offer the best Volvo buses for hire in Pune, perfect for any occasion, from corporate events to family trips."
    }
  ],
  "tableData": [
    ["Volvo Sleeper Bus Rent Per Km", "Volvo Bus Hire in Pune Near Me"],
    ["Sleeper Bus on Rent in Pune", "Top AC Sleeper Bus on Rent in Pune"],
    ["AC Sleeper Bus Rental Service", "AC 50 Seater Bus Sleeper on Rent"],
    ["Volvo Bus on Rent in Pune", "Volvo Bus on Rent in Pune for Family"],
    ["Sleeper Bus on Rent in Pune", "Hire Luxury Bus on Rent"],
    ["Hire Luxury Bus on Rent Near Me in Pimpri Chinchwad", "Luxury Bus on Rent in Pune"],
    ["Volvo Bus on Rent for Picnic", "Volvo Bus on Rent for Corporate Event"],
    ["Volvo Bus on Rent for Corporate Picnic", "Volvo Bus on Rent for Ashtavinayak Darshan"],
    ["Volvo Bus on Rent for 12 Jyotirlinga Darshan", "Sleeper Bus on Rent in Pune"],
    ["Volvo Bus on Rent in Pimpri Chinchwad", "Volvo Bus on Rent in Pune for Marriage Function"],
    ["Best Volvo Bus for Hire in Pune", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Premium Volvo Bus Rental Services in Pune",
        "WhyChoosedescription": "We offer luxurious Volvo bus rentals in Pune, perfect for corporate events, group tours, or weddings. Volvo buses are renowned for their superior comfort, advanced safety features, and modern amenities, ensuring a smooth and premium travel experience."
    },
    {
        "WhyChooseheading": "Modern Volvo Buses with Top-Notch Amenities",
        "WhyChoosedescription": "Our Volvo buses come equipped with plush leather seats, air-conditioning, Wi-Fi, entertainment systems, and ample legroom. Whether you're embarking on a short city tour or a long-distance journey, our Volvo buses provide the utmost comfort and convenience."
    },
    {
        "WhyChooseheading": "Perfect for Long-Distance and Group Travel",
        "WhyChoosedescription": "Volvo buses are ideal for long-distance travel, offering exceptional comfort on extended journeys. Whether you're traveling to destinations like Mumbai, Goa, or Mahabaleshwar, our Volvo buses ensure a relaxed and comfortable ride for your group."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
        "WhyChoosedescription": "Our skilled and professional drivers are experienced in handling Volvo buses, ensuring safe and timely travel. They are well-versed with Pune's roads and long-distance routes, providing a smooth and efficient travel experience for all passengers."
    },
    {
        "WhyChooseheading": "Affordable Luxury with Competitive Pricing",
        "WhyChoosedescription": "We provide Volvo bus rental services at competitive prices, ensuring that you get luxury travel without the premium cost. Our transparent pricing means no hidden fees, so you can plan your event or trip with confidence."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
        "WhyChoosedescription": "Our Volvo buses are available 24/7, allowing you to schedule travel at any time that suits your needs. Whether it's an early morning departure or a late-night return, we ensure your travel plans are supported without delays."
    },
    {
        "WhyChooseheading": "Easy Booking with Real-Time Updates",
        "WhyChoosedescription": "Booking a Volvo bus is simple and quick. After confirmation, you’ll receive real-time updates, including driver contact details, bus tracking information, and arrival times, making your travel logistics seamless and stress-free."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Volvo Buses",
        "WhyChoosedescription": "Our Volvo buses are regularly cleaned, sanitized, and well-maintained to ensure they meet the highest standards of hygiene and safety. We prioritize passenger comfort and safety with every journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Easy Transactions",
        "WhyChoosedescription": "We offer a variety of secure payment options, including UPI, credit/debit cards, digital wallets, and cash, making the booking and payment process as convenient as possible."
    }
]






























    }

const faqData = [
    {
        id: 1,
        question: 'How can I rent a Volvo bus in Pune with Samarth Travels?',
        answer: 'Renting a Volvo bus with Samarth Travels is simple and convenient. You can book your Volvo bus via our website or by contacting our customer support team. Just provide your travel details, including your destination, number of passengers, and dates, and we will arrange a luxurious Volvo bus for your journey.',
    },
    {
        id: 2,
        question: 'What are the types of Volvo buses available for rent in Pune?',
        answer: 'Samarth Travels offers premium Volvo buses in various configurations, including 32-seater, 40-seater, and 50-seater options. Our Volvo buses come with luxury amenities such as reclining seats, air conditioning, onboard entertainment, and Wi-Fi, ensuring a comfortable and stylish journey.',
    },
    {
        id: 3,
        question: 'Are Volvo buses suitable for both short and long-distance travel?',
        answer: 'Yes, Volvo buses are ideal for both short and long-distance journeys. They are built for comfort and safety, featuring premium seating, AC, reading lights, and more. Whether it’s a day trip, corporate outing, or long-distance tour, a Volvo bus is perfect for a comfortable travel experience.',
    },
    {
        id: 4,
        question: 'What are the rental charges for a Volvo bus in Pune?',
        answer: 'The rental charges for Volvo buses depend on factors such as the bus size, trip duration, and distance. For local bookings, prices start at ₹40/km for the 32-seater Volvo. For outstation trips, charges are typically calculated per day with a minimum km usage. Please contact us for a personalized quote.',
    },
    {
        id: 5,
        question: 'Does the rental include a driver and fuel?',
        answer: 'Yes, all Volvo bus rentals include a professional driver and fuel costs. Any additional charges like tolls, parking fees, and permits will be communicated upfront to ensure complete transparency.',
    },
    {
        id: 6,
        question: 'Can I customize the pickup and drop-off locations for the Volvo bus rental?',
        answer: 'Absolutely! We provide flexible pickup and drop-off location options based on your preferences and convenience. Whether it’s from your office, hotel, or home, we will arrange everything to suit your travel needs.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for Volvo bus rentals?',
        answer: 'Yes, Samarth Travels offers 24/7 customer support for Volvo bus rentals. Whether you need help with bookings, itinerary changes, or assistance during your trip, our team is always available to ensure your journey goes smoothly.',
    },
];

const testimonials = [
    {
        name: 'Mr. Vikram Agarwal',
        role: 'Corporate Head',
        text: 'We hired a 40-seater Volvo bus from Samarth Travels for our corporate conference in Lonavala. The bus was top-notch with luxurious seating, AC, and Wi-Fi. Our team enjoyed the ride, and the service was impeccable. I highly recommend Samarth Travels for any corporate travel needs.',
        image: '/img/testimonial/testi_volvo_vikram.jpg',
    },
    {
        name: 'Mrs. Priya Gupta',
        role: 'Wedding Planner',
        text: 'For a wedding event, I booked a 50-seater Volvo bus from Samarth Travels. The bus was elegant, comfortable, and equipped with all the modern amenities. It added a touch of luxury to our guests’ experience. I will definitely use Samarth Travels again for future events.',
        image: '/img/testimonial/testi_volvo_priya.jpg',
    },
   
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus On Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/volvo-bus-on-rent-pune.jpg", // Replace with the correct image URL
  "description": "Rent Volvo buses in Pune for family trips, corporate events, picnics, and religious tours. Available in sleeper AC models, ideal for long-distance travel. Comfortable, luxurious, and affordable Volvo bus hire services by Samarth Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6123"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/volvo-bus-on-rent-pune" // Replace with the actual page URL
  }
};





    return (
        <div>

<Helmet>
  <title>Volvo Bus On Rent in Pune | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent Volvo sleeper buses in Pune for family trips, corporate events, picnics, and outstation tours like Ashtavinayak Darshan and 12 Jyotirlinga Darshan. Comfortable and affordable Volvo bus rental services by Samarth Travels." 
  />
  <meta 
    name="keywords" 
    content="Volvo Sleeper Bus rent per km, Volvo bus hire in pune near me, Sleeper Bus on rent in Pune, Top Ac Sleeper Bus On Rent in Pune, AC Sleeper Bus Rental Service, Ac 50 Seater Bus Sleeper on Rent, Volvo Bus On Rent in Pune, Volvo bus on rent in pune for family, Sleeper Bus on rent in Pune, Hire Luxury Bus On Rent, Hire luxury bus on rent near me pimpri chinchwad, luxury bus on rent in pune, Volvo Bus On Rent in for Picnic, Volvo bus on rent for Corporate Event, Volvo Bus On Rent For Corporate Picnic, Volvo bus on rent for ashtavinayak darshan, Volvo Bus On Rent for 12 Jyotirlinga Darshan, sleeper bus on rent in pune, volvo bus on rent in pimpri chinchwad, volvo bus on rent in pune for marriage function, Best Volvo Bus for Hire in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Volvobusonrentinpune;